module.exports = __webpack_public_path__ + "img/xssbg.c227838b.jpg";